import { render } from "./authorization.vue?vue&type=template&id=93d10192"
import script from "./authorization.vue?vue&type=script&lang=js"
export * from "./authorization.vue?vue&type=script&lang=js"

import "./authorization.vue?vue&type=style&index=0&id=93d10192&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__